export default __webpack_public_path__ + "static/media/screen2.30bb983c.png";